import { CommonModule } from '@angular/common';
import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { WhiteLabelChartFilterActions } from 'src/app/core/common';
import { WhiteLabelTotalSessions } from 'src/app/core/data/model';
import { BaseFilterComponent } from 'src/app/shared/component/base-filter-component/base-filter-component';
import { StatisticsCardFilter } from 'src/app/shared/interfaces';
import { NumberFormatPipe } from 'src/app/shared/pipes';

@Component({
  selector: 'app-statistics-chart-filter',
  standalone: true,
  imports: [CommonModule, MatIconModule, NumberFormatPipe],
  templateUrl: './statistics-chart-filter.component.html',
  styleUrls: ['./statistics-chart-filter.component.scss'],
})
export class StatisticsChartFilterComponent
  extends BaseFilterComponent<{ selectedFilter: WhiteLabelChartFilterActions }>
  implements OnInit, OnChanges
{
  statisticsFiltersData: StatisticsCardFilter[] = [];

  // inputs
  @Input() cardsData: WhiteLabelTotalSessions;

  // getters
  get selectedFilter(): AbstractControl {
    return this.form.get('selectedFilter');
  }

  // constants
  Math = Math;
  constructor(injector: Injector) {
    super(['WHITE_LABEL_DASHBOARD'], injector);
  }

  // hooks
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['cardsData']) {
      this.setStatisticsCardData();
    }
  }
  override ngOnInit(): void {
    super.ngOnInit();
    this.setStatisticsCardData();
    this.validateIfCardNotFound();
  }

  // publics
  onSelectFilter(filter: StatisticsCardFilter): void {
    this.selectedFilter.setValue(filter.cardAction);
    this.onSearch();
  }

  // overrides
  protected override initializeForm(): void {
    this.form = new FormGroup({
      selectedFilter: new FormControl(WhiteLabelChartFilterActions.BENEFICIARIES),
    });
  }
  // privates
  private setStatisticsCardData(): void {
    this.statisticsFiltersData = [
      {
        label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_CLIENTS'],
        statistics: this.cardsData?.benficiaryData.total ?? 0,
        statisticsPercentage: this.cardsData?.benficiaryData.rate ?? 0,
        cardAction: WhiteLabelChartFilterActions.BENEFICIARIES,
      },
      {
        label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_SESSIONS'],
        statistics: this.cardsData?.sessionData.total || 0,
        statisticsPercentage: this.cardsData?.sessionData.rate || 0,
        cardAction: WhiteLabelChartFilterActions.SESSIONS,
      },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_LETTERS'],
      //   statistics: this.cardsData?.lettersData.total || 0,
      //   statisticsPercentage: this.cardsData?.lettersData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.LETTERS,
      // },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_MINUTES'],
      //   statistics: this.cardsData?.minutesData.total || 0,
      //   statisticsPercentage: this.cardsData?.minutesData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.MINUTES,
      // },
      // {
      //   label: this.translationsList['WHITE_LABEL_DASHBOARD']['STATISTICS_FILTERS']['NUMBER_OF_FACES'],
      //   statistics: this.cardsData?.pagesData.total || 0,
      //   statisticsPercentage: this.cardsData?.pagesData.rate || 0,
      //   cardAction: WhiteLabelChartFilterActions.PAGES,
      // },
    ];
  }

  private validateIfCardNotFound(): void {
    if (!Object.values(WhiteLabelChartFilterActions).includes(this.selectedFilter.value)) {
      this.selectedFilter.setValue(WhiteLabelChartFilterActions.BENEFICIARIES);
      this.onSearch();
    }
  }
}
